import { memo, useCallback } from "react";

import { getTodaysDate } from "@/lib/dayjs/get-todays-date";

import { YearOrMonthSelectBox } from "./components";
import { useYearAndMonth } from "./hooks";

type Props = {
	initialDt?: string;
	onSelectYearOrMonthCallback: (input: { startDt: string; endDt: string }) => void;
};

export const YearAndMonthSelectBox = memo(({ initialDt, onSelectYearOrMonthCallback }: Props) => {
	const { year, onSetYear, month, onSetMonth, yearOptions, monthOptions, onGetStartAndEndDt } = useYearAndMonth({
		initialDt: initialDt ?? getTodaysDate(),
	});

	const handleOnSetYear = useCallback(
		(currentYear: string) => {
			onSetYear(currentYear);
			const { startDt, endDt } = onGetStartAndEndDt({ year: currentYear, month });

			onSelectYearOrMonthCallback({ startDt, endDt });
		},
		[onSetYear, onGetStartAndEndDt, month, onSelectYearOrMonthCallback],
	);

	const handleOnSetMonth = useCallback(
		(currentMonth: string) => {
			onSetMonth(currentMonth);
			const { startDt, endDt } = onGetStartAndEndDt({ year, month: currentMonth });

			onSelectYearOrMonthCallback({ startDt, endDt });
		},
		[onSetMonth, onGetStartAndEndDt, year, onSelectYearOrMonthCallback],
	);

	return (
		<div className="flex flex-col gap-y-4">
			<h5 className="font-semibold">表示する年と月</h5>
			<div className="mx-4 flex gap-x-2">
				<YearOrMonthSelectBox yearOrMonth={year} onSet={handleOnSetYear} options={yearOptions} suffix="年" />
				<YearOrMonthSelectBox yearOrMonth={month} onSet={handleOnSetMonth} options={monthOptions} suffix="月" />
			</div>
		</div>
	);
});

YearAndMonthSelectBox.displayName = "YearAndMonthSelectBox";
